<template>
  <ValidationProvider :name="$attrs.label" :immediate="true" :rules="rules">
    <v-combobox
      v-model="inputValue"
      slot-scope="{ errors, valid }"
      clearable
      :error-messages="errors"
      :items="items"
      :disabled="disabled"
      :success="valid && success"
      v-bind="$attrs"
      v-on="$listeners"
    />
  </ValidationProvider>
</template>
<script>
import { ValidationProvider } from 'vee-validate';
import { convertToFloatFormat } from '../../helper';

export default {
  components: {
    ValidationProvider,
  },
  props: {
    value: { type: String, default: null },
    items: { type: Array, default: () => [] },
    rules: {
      type: [Object, String],
      default: '',
    },
    disabled: { type: Boolean, default: false },
    success: { type: Boolean, default: false },
  },
  computed: {
    inputValue: {
      get() {
        return this.value
          ? parseFloat(convertToFloatFormat(this.value)).toLocaleString('de-DE', {
              minimumFractionDigits: 2,
            })
          : null;
      },
      set(value) {
        const parsedValue = parseFloat(convertToFloatFormat(value)).toFixed(2);
        this.$emit('update', parsedValue);
        this.$emit('input', parsedValue);
      },
    },
  },
};
</script>
<style scoped></style>
